export default `
  query($itemId: String!, $flow: String) {
    itemPendingDenouncesCount(itemId: $itemId, flow: $flow) {
      count
    }
  }
`;